import React, { useEffect, useState } from 'react'
import styles from './style.module.css';
import { upcomingCampusDrive } from '../../action/campusDrive';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt,
    faCalendarCheck,
    faClock
} from '@fortawesome/free-solid-svg-icons';
const CampusDriveAdvertiseBanner = ({ onRegister }) => {
    const [campusDrives, setCampusDrives] = useState([])

    useEffect(() => {
        upcomingCampusDrive().then((res) => {
            if (res.status) {
                setCampusDrives(res.result)
            }
        })
    }, [])
    const [activeIndex, setActiveIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);

    // Auto rotate every 6 seconds (only if more than 1 drive)
    useEffect(() => {
        if (campusDrives.length <= 1 || isHovered) return;

        const interval = setInterval(() => {
            setActiveIndex(prev =>
                prev === campusDrives.length - 1 ? 0 : prev + 1
            );
        }, 10000);

        return () => clearInterval(interval);
    }, [campusDrives, isHovered]);

    if (!campusDrives.length) return null;

    const drive = campusDrives[activeIndex];

    return (

        <div className='col-md-12 my-3'>
            <div className={`${styles['job-lists']}`}>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className={`${styles['intern-heading']}`}>Upcoming Campus Drive</h3>
                        <p className='mb-1'>Don’t miss your next opportunity—track all upcoming campus drives here.</p>
                        <hr />

                        <div className={
                            activeIndex % 2 === 0
                                ? styles['cp-template-first']
                                : styles['cp-template-sec']
                        }
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}>
                            <h3>{drive.DRIVE_NAME}</h3>
                            <p>{drive.DRIVE_DESCRIPTION || 'An upcoming campus placement drive exclusively for registered employers. Participate to hire pre-registered students, review profiles, and manage the complete hiring process from a single dashboard.'}</p>
                            <div className='d-flex align-items-center'>
                                <div className={`${styles['fs-16']}`}><FontAwesomeIcon className={`${styles['loc-icon']}`} icon={faMapMarkerAlt} /> {drive.COLLEGE_NAME}</div>
                                <div className={`${styles['fs-16']} mx-3`}><FontAwesomeIcon className={`${styles['cal-icon']}`} icon={faCalendarCheck} /> {drive.DRIVE_DATE}</div>
                                <div className={`${styles['fs-16']}`}><FontAwesomeIcon className={`${styles['time-icon']}`} icon={faClock} /> {drive.DRIVE_START_TIME} – {drive.DRIVE_END_TIME}</div>
                            </div>
                            <div className='mt-3'>
                                <button onClick={() => {
                                    onRegister(drive)
                                }} className={`${styles['reg-btn']}`}>Register Now</button>
                            </div>
                        </div>
                       
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        </div>
                    </div>
                </div>
            </div>
        </div >


    );
};

export default CampusDriveAdvertiseBanner;
